import { allDatesField } from './fields/allDates.field';
import { availableDatesField } from './fields/availableDates.field';

export const deliveryCalendarPolicies = {
    allDates: allDatesField,
    availableDates: availableDatesField,
};
